import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui/Button";
import styles from "./ReloadModal.module.scss";

export const ReloadModal = NiceModal.create(() => {
    const { t } = useTranslation();
    const modal = useModal();
    const reload = () => {
        modal.remove();
        window.location.reload();
    };

    return (
        <div className={styles.reloadWindowWrapper}>
            <div className={styles.reloadWindow}>
                <div className={styles.reloadWindowInfo}>
                    {t("modal.reload.title")}
                    <br />
                    {t("modal.reload.description")}
                </div>

                <Button fullWidth className={styles.reloadWindowAction} onClick={reload}>
                    {t("modal.reload.action")}
                </Button>
            </div>
        </div>
    );
});
